<section class="main-section usercenter-section p-3">
    <header class="d-md-flex d-block align-items-center main-heading error-log-heading">
        <div class="d-flex align-items-center">
            <a class="btn btn-link me-3 p-0 d-block d-xl-none" data-bs-toggle="offcanvas" href="#offcanvasExample"
                role="button" aria-controls="offcanvasExample">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 7H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
                    <path d="M3 12H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
                    <path d="M3 17H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
                </svg>
            </a>
            <h3 class="heading-span text-black">
                <span>Trace Report</span>
            </h3>
        </div>
        <div class="col-md-10">
            <div class="d-flex justify-content-end me-3">
                <div class="input-group me-2 user-center-search mt-2 mt-md-0">
                    <span class="input-group-text bg-transparent" id="basic-addon1" (click)="getAllLogs()">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M15.7138 6.8382C18.1647 9.28913 18.1647 13.2629 15.7138 15.7138C13.2629 18.1647 9.28913 18.1647 6.8382 15.7138C4.38727 13.2629 4.38727 9.28913 6.8382 6.8382C9.28913 4.38727 13.2629 4.38727 15.7138 6.8382"
                                stroke="#999999" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M19 19L15.71 15.71" stroke="#999999" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </span>
                    <input type="text" class="form-control usercenter-searchcontrol ps-0 bg-white" placeholder="Search"
                        aria-label="Username" aria-describedby="basic-addon1" [(ngModel)]="searchTerm"
                        (keyup.enter)="this.pageNumber = 0;this.pageOffSet = 0;getAllLogs()" />
                </div>
                <mat-icon matTooltip="{{searchBy}}" matTooltipPosition="above" class="fs-22 m-2">info</mat-icon>
            </div>
        </div>
    </header>
    <div class="tab-content">
        <div>
            <div *ngIf="traceReportLogs.length" class="table-responsive tab-table ticket-management-table">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            
                            <th class="contactNumber-header">Name
                                <mat-icon *ngIf="sortNameAsc"
                                    (click)="sortNameAsc=false;getAllLogs('userName','asc')">arrow_upward</mat-icon>
                                <mat-icon *ngIf="!sortNameAsc"
                                    (click)="sortNameAsc=true;getAllLogs('userName','desc')">arrow_downward</mat-icon>
                            </th>
                            <th class="contactNumber-header">Date</th>
                            <th class="contactNumber-header">Time</th>
                            <th class="contactNumber-header">Role</th>
                            <th class="contactNumber-header">Report Id</th>
                            <th class="contactNumber-header">Report Name
                                <mat-icon *ngIf="sortReportNameAsc"
                                    (click)="sortReportNameAsc = false; getAllLogs('reportName','asc')">arrow_upward</mat-icon>
                                <mat-icon *ngIf="!sortReportNameAsc"
                                    (click)="sortReportNameAsc = true; getAllLogs('reportName','desc')">arrow_downward</mat-icon>
                            </th>
                            <th class="action-header">Viewed From</th>
                            <th class="contactNumber-header">Message</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let log of traceReportLogs; let i = index">
                            
                            <td>
                                <p class="mat-account-detail mb-0" [matTooltip]="log.userName!">
                                    {{log.userName}}
                                </p>
                            </td>
                            <td>
                                <p class="mat-account-detail mb-0" >
                                     {{log.loggedDate | date : 'dd/MM/yyyy'}}
                                </p>
                            </td>
                             <td>
                                <p class="mat-account-detail mb-0" >
                                     {{log.loggedDate | date : 'HH:mm:ss'}}
                                </p>
                            </td>
              
                            <td>
                                <p class="mat-account-detail mb-0" [matTooltip]="log.roleName!">
                                    {{log.roleName}}
                                </p>
                            </td>
                            <td>
                                <p (click)="viewExceptionModal(log.reportId!)" class="mat-account-detail mb-0 cursor-pointer" [matTooltip]="log.reportId!">
                                    {{log.reportId}}
                                </p>
                            </td>
                            <td>
                                <p (click)="viewExceptionModal(log.reportName!)" class="mat-account-detail mb-0 cursor-pointer" [matTooltip]="log.reportName!">
                                    {{log.reportName}}
                                </p>
                            </td>
                            <td>
                                <p class="mat-account-detail mb-0" [matTooltip]="log.clientAccountName!">
                                    {{log.clientAccountName ? log.clientAccountName : '-'}}
                                </p>
                            </td>
                            <td>
                                <p (click)="viewExceptionModal(log.message!)" class="mat-account-detail read-more-detail mb-0 cursor-pointer"
                                  [ngClass]="log.status ? 'success-response' : 'error-response'" [matTooltip]="log.message!">
                                    {{log.message}}
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <mat-paginator *ngIf="traceReportLogs.length" [length]="totalRecords" [pageSize]="pageSize"
                [pageIndex]="pageNumber" (page)="changePage($event)" [pageSizeOptions]="[10, 20, 50, 100, 500, 1000]">
            </mat-paginator>
            <div *ngIf="!traceReportLogs.length" class="noDataFound">
                <h1>{{'No Data Found'}}</h1>
            </div>
        </div>
    </div>
</section>